<template lang="pug">
.game-task-card(v-if="gameList.length > 0" v-platform-expose="onModuleExpose")
  .game-task-main(@click="onBtnClick")
    .task-left
      SafeImg.icon-new-block(:src="moduleData.taskImgUrl || ''")
    .task-mid
      .game-title {{ moduleData.taskName }}
      .game-subtitle
        img.coin-icon(src="https://m.hellobike.com/fd018348_new_coin.png")
        span.high-text 最高
        span.coin-text +{{ moduleData.amount || 0 }}
    .task-right
      .btn {{ moduleData.btnName }}
  //- 游戏卡片横滑列表
  .game-list-scroll(ref="gameListScroll")
    .game-list
      .game-item(
        v-for="(game, index) in gameList"
        :key="game.taskCode"
        ref="gameItems"
        :class="{ 'can-done': isCanDone(game) }"
        v-platform-expose="{ handler: onGameItemExpose, data: game, once: false }"
        @click="onGameItemClick(game)"
      )
        .game-icon-wrap
          SafeImg.game-icon-img(:src="isCanDone(game) ? REWARD_IMG : game.taskImgUrl")
          .game-amount-overlay(v-if="isCanDone(game)") {{ game.amount }}
        .btn-claim(v-if="isCanDone(game)") 领奖励
        .game-label(v-else) {{ game.taskName }}
</template>

<script>
import SafeImg from '@/components/safe-img';
// import { scrollToMid } from '@/utils';
import Toast from '@/components/toast';
import { TaskStatus } from '@/const/task';
import { newMapTaskV2 } from '@/utils/mappers';
import { handleTaskBtnClick } from '../../common/task';
import SPM from '../../common/spm';

const REWARD_IMG = 'https://m.hellobike.com/3b4137ba57.png';

export default {
  name: 'GameTaskCard',
  components: {
    SafeImg,
  },
  inject: {
    isSupportAd: { default: () => () => false },
  },
  props: {
    moduleData: {
      type: Object,
      required: true,
    },
    doubleInformation: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      REWARD_IMG,
      doubleInformationHistory: null,
    };
  },
  computed: {
    gameList() {
      if (!this.moduleData.taskCouponList?.length) return [];
      return this.moduleData.taskCouponList.map((item) => ({
        ...newMapTaskV2(item),
        ...item,
      }));
    },
  },
  watch: {
    doubleInformation: {
      handler(newVal) {
        this.doubleInformationHistory = { ...newVal };
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // this.scrollToNextGame();
  },
  methods: {
    // 模块曝光埋点
    onModuleExpose() {
      SPM.moduleExpose({
        moduleId: 'platform_gameTasks',
        contentId: 'platform_gameTasks',
      });
    },
    // 游戏宫格曝光埋点
    onGameItemExpose(_entry, game) {
      if (!game) return;
      const {
        taskName, taskCode, taskStatus, amount,
      } = game;
      SPM.moduleExpose({
        moduleId: 'platform_gamesGrid',
        contentId: 'platform_gamesGrid',
        businessInfo: {
          task_name: taskName,
          taskid: taskCode,
          taskState: taskStatus,
          taskBonus: amount,
        },
      });
    },
    // 判断游戏任务是否处于「可领奖」状态
    isCanDone(game) {
      return game.status === TaskStatus.CAN_DONE;
    },
    // 点击整个游戏任务的按钮触发，自动开始第一个未完成游戏任务
    onBtnClick() {
      const firstGameItem = this.gameList.find((t) => t.status !== TaskStatus.CAN_DONE);
      if (firstGameItem) {
        const { taskCode, taskName } = firstGameItem;
        SPM.clickButton({
          buttonName: 'platform_playGames',
          businessInfo: {
            taskid: taskCode,
            task_name: taskName,
          },
        });
        this.doTask(firstGameItem);
      } else {
        Toast.show('今日已完成，明日再来');
      }
    },
    // 点击单个游戏触发
    onGameItemClick(game) {
      const {
        taskName, taskCode, taskStatus, amount,
      } = game;
      SPM.clickButton({
        buttonName: 'platform_gamesGrid',
        businessInfo: {
          task_name: taskName,
          taskid: taskCode,
          taskState: taskStatus,
          taskBonus: amount,
        },
      });
      this.doTask(game);
    },
    async doTask(task) {
      const options = {
        scene: 'task_list',
        needReceiveCoupon: true,
        doubleInformationHistory: this.doubleInformationHistory,
        supportAd: this.isSupportAd(),
      };
      await handleTaskBtnClick.call(this, task, options);
      this.doubleInformationHistory = null;
    },
    // scrollToNextGame() {
    //   if (!this.gameList || this.gameList.length < 5) return;
    //   const nextIdx = this.gameList.findIndex(
    //     (g) => g.status !== TaskStatus.DONE,
    //   );

    //   if (nextIdx < 0) return;
    //   const items = this.$refs.gameItems;
    //   const scroll = this.$refs.gameListScroll;
    //   if (items && items[nextIdx] && scroll) {
    //     scrollToMid(items[nextIdx], scroll);
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
.game-task-card {
  padding: 0.12rem 0.12rem 0;
  display: flex;
  flex-direction: column;

  .game-task-main {
    width: 100%;
    display: flex;
    align-items: center;
    padding-bottom: 0.1rem;

    .task-left {
      margin-right: 0.1rem;
      flex-shrink: 0;

      .icon-new-block {
        overflow: hidden;
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 0.12rem;
      }
    }

    .task-mid {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .game-title {
        font-size: 0.14rem;
        font-weight: 500;
        color: #242729;
        line-height: 0.2rem;
        margin-bottom: 0.02rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .game-subtitle {
        display: flex;
        align-items: center;
        font-size: 0.12rem;

        .coin-icon {
          width: 0.16rem;
          height: 0.16rem;
          margin-top: 0.01rem;
          margin-right: 0.02rem;
        }

        .high-text {
          font-weight: 400;
          color: #5a6066;
        }

        .coin-text {
          font-weight: 600;
          color: #fe852a;
        }
      }
    }

    .task-right {
      flex-shrink: 0;
      margin-left: 0.08rem;

      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 0.62rem;
        height: 0.28rem;
        line-height: 0.28rem;
        font-size: 0.12rem;
        font-weight: 500;
        border-radius: 1rem;
        white-space: nowrap;
        color: #000;
        background: #ffe888;
      }
    }
  }

  // 游戏卡片横滑列表
  .game-list-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    margin-left: 0.4rem;
    margin-right: -0.12rem;
    padding-right: 0.12rem;
    padding-bottom: 0.1rem;

    &::-webkit-scrollbar {
      display: none;
    }

    .game-list {
      display: flex;
      gap: 0.06rem;
      width: max-content;

      .game-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 0.64rem;
        cursor: pointer;
        padding: 0.02rem 0;

        .game-icon-wrap {
          position: relative;
          width: 0.38rem;
          height: 0.38rem;

          .game-icon-img {
            width: 0.38rem;
            height: 0.38rem;
            border-radius: 0.1rem;
            overflow: hidden;
          }
        }

        .game-label {
          display: block;
          margin-top: 0.06rem;
          font-size: 0.12rem;
          color: #242729;
          text-align: center;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .btn-claim {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 0.03rem;
          width: 0.47rem;
          padding: 0.02rem 0.07rem;
          line-height: 0.18rem;
          font-family: PingFang SC, sans-serif;
          font-size: 0.1rem;
          font-weight: 500;
          border-radius: 1rem;
          white-space: nowrap;
          background: #fe852a;
          color: #fff;
        }

        // 待领奖：显示金额覆盖层
        &.can-done {
          .game-amount-overlay {
            display: flex;
            position: absolute;
            inset: 0;
            align-items: center;
            justify-content: center;
            font-family: DIN Alternate, sans-serif;
            font-size: 0.12rem;
            font-weight: 600;
            color: #fe852a;
          }
        }
      }
    }
  }
}
</style>
